import { images } from "../assets/img";

export function LogoBanner() {
  const iconsItems = ["aat", "xero", "quickbooks", "sage", "freeagent"];
  return (
    <div id="homeLogos">
      {iconsItems.map((el) => (
        <img src={images.icon[el]} alt={el} key={el} />
      ))}
    </div>
  );
}
